import cancelInvoicesService from "@/services/cancelInvoicesService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await cancelInvoicesService.create(formData);
      dispatch(
        "common/showSuccess",
        "Stornieringsabrechnung wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Stornieringsabrechnung konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await cancelInvoicesService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Stornierungsabrechnungen für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachement({ dispatch }, formData) {
    try {
      const res = await cancelInvoicesService.getAttachement(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Stornieringsabrechnung-PDF für diese Buchung konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await cancelInvoicesService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Stornieringsabrechnung wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Stornieringsabrechnung für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
